(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["maison-marquee"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('maison-marquee')) {
  customElements.define('maison-marquee', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const viewport = this.querySelector('.maison-marquee__viewport');
      const track = this.querySelector('.maison-marquee__track');
      const list = track?.querySelector('ul');
      if (!viewport || !list || list.children.length < 2) return;
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      const speed = this.closest('.maison-jewels') ? 48 : 44;
      let keyboard = false;
      let paused = false;
      let drag = null;
      let suppressClick = false;
      let distance = 0;
      let duration = 0;
      const update = () => {
        const running = this.visible && !document.hidden && !reduced.matches && !keyboard && !drag && !paused;
        this.toggleAttribute('data-running', Boolean(running && this.motion));
        if (this.motion) running ? this.motion.play() : this.motion.pause();
      };
      this.querySelector('.maison-marquee__pause')?.addEventListener('click', event => {
        paused = !paused;
        event.currentTarget.setAttribute('aria-pressed', String(paused));
        update();
      }, { signal });
      const rebuild = () => {
        const progress = duration ? (Number(this.motion?.currentTime || 0) % duration) / duration : 0;
        this.motion?.cancel();
        this.motion = null;
        this.toggleAttribute('data-ready', false);
        if (reduced.matches || keyboard || !this.visible) {
          track.querySelector('[data-maison-clone]')?.remove();
          update();
          return;
        }
        if (!track.querySelector('[data-maison-clone]')) {
          const clone = list.cloneNode(true);
          clone.dataset.maisonClone = '';
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
          clone.querySelectorAll('[data-shopify-editor-block]').forEach(node => node.removeAttribute('data-shopify-editor-block'));
          clone.querySelectorAll('a, button, input, [tabindex]').forEach(node => node.setAttribute('tabindex', '-1'));
          track.append(clone);
        }
        distance = list.getBoundingClientRect().width;
        if (!distance) return;
        duration = distance / speed * 1000;
        viewport.scrollLeft = 0;
        this.motion = track.animate([{ transform: 'translateX(0)' }, { transform: `translateX(-${distance}px)` }], { duration, iterations: Infinity, easing: 'linear' });
        this.motion.currentTime = progress * duration;
        this.setAttribute('data-ready', '');
        update();
      };
      const seek = delta => {
        if (!this.motion || !duration) { viewport.scrollLeft += delta; return; }
        const next = Number(this.motion.currentTime || 0) + delta / speed * 1000;
        this.motion.currentTime = ((next % duration) + duration) % duration;
      };
      viewport.addEventListener('wheel', event => {
        if (event.ctrlKey || !this.motion) return;
        if (Math.abs(event.deltaX) <= Math.abs(event.deltaY)) return;
        const delta = event.deltaX;
        if (!delta) return;
        event.preventDefault();
        seek(delta * (event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? viewport.clientWidth : 1));
      }, { signal, passive: false });
      viewport.addEventListener('pointerdown', event => {
        if (event.button !== 0 || reduced.matches || keyboard) return;
        suppressClick = false;
        drag = { id: event.pointerId, startX: event.clientX, startY: event.clientY, x: event.clientX, active: false };
        update();
      }, { signal });
      viewport.addEventListener('pointermove', event => {
        if (!drag || drag.id !== event.pointerId) return;
        const dx = event.clientX - drag.startX;
        if (!drag.active) {
          if (Math.abs(dx) < 6) return;
          if (event.pointerType === 'touch' && Math.abs(event.clientY - drag.startY) > Math.abs(dx)) return;
          drag.active = true;
          suppressClick = true;
          viewport.setPointerCapture(event.pointerId);
          this.setAttribute('data-dragging', '');
        }
        seek(drag.x - event.clientX);
        drag.x = event.clientX;
      }, { signal });
      const finish = event => {
        if (!drag || drag.id !== event.pointerId) return;
        if (viewport.hasPointerCapture(event.pointerId)) viewport.releasePointerCapture(event.pointerId);
        drag = null;
        this.removeAttribute('data-dragging');
        update();
      };
      window.addEventListener('pointerup', finish, { signal });
      viewport.addEventListener('pointercancel', finish, { signal });
      viewport.addEventListener('lostpointercapture', finish, { signal });
      viewport.addEventListener('dragstart', event => event.preventDefault(), { signal });
      viewport.addEventListener('click', event => {
        if (suppressClick) { event.preventDefault(); event.stopPropagation(); suppressClick = false; }
      }, { signal, capture: true });
      viewport.addEventListener('focusin', event => {
        if (!event.target.matches(':focus-visible')) return;
        keyboard = true;
        this.setAttribute('data-keyboard', '');
        rebuild();
      }, { signal });
      viewport.addEventListener('focusout', event => {
        if (viewport.contains(event.relatedTarget)) return;
        keyboard = false;
        this.removeAttribute('data-keyboard');
        rebuild();
      }, { signal });
      document.addEventListener('visibilitychange', update, { signal });
      reduced.addEventListener('change', rebuild, { signal });
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        if (this.visible && !this.motion) rebuild();
        else update();
      });
      this.observer.observe(this);
      this.resizeObserver = new ResizeObserver(() => {
        if (this.visible && Math.abs(list.getBoundingClientRect().width - distance) > 1) rebuild();
      });
      this.resizeObserver.observe(list);
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
      this.resizeObserver?.disconnect();
      this.motion?.cancel();
      this.motion = null;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
